import { IApplicationState } from '../../types/redux';

export const selectIsCompilation = (state: IApplicationState): boolean => {
  return state.isCompilation;
};
